<template>
  <div id="nea-page">
    <page-header-component
      v-if="topics"
      @filterChange="filterChange"
      icon="bi bi-diagram-2"
      title="Named Entity Analysis (NEA)"
      :topics="topics"
    />
    <div class="row m-t-10" v-if="is_ner">
      <div class="col-3 px-gap">
        <div class="bg-white rounded p-3 shade">
          <h5>Daftar Entitas</h5>
          <input
            id="cari-entitas"
            type="text"
            name="q"
            v-model="q_search"
            @keyup="searchEntity"
            class="form-control form-custom m-b-5"
            placeholder="Cari Entitas"
          />
          <multiselect
            id="jenis-entitas"
            v-model="selected_entity"
            :options="entity_option"
            placeholder="Pilih Jenis Entitas"
            @select="changeEntity"
            label="text"
            track-by="text"
          />

          <p
            class="m-t-10 p-1 bg-warning-lighter"
            align="center"
            v-if="loading_state.entity"
          >
            Loading...
          </p>

          <div
            class="entity-result m-t-10"
            v-else-if="entity_result.length > 0"
          >
            <div
              id="entitas"
              class="row m-t-10"
              :class="entity._id == selected_entity_detail._id ? 'active' : ''"
              v-for="(entity, index) in entity_result"
              :key="index"
              @click="entityDetail(entity)"
            >
              <div class="col-2 no-padding no-margin">
                <div
                  class="bg-icon"
                  :style="
                    entity.type in bg_ner
                      ? 'background-color:' + bg_ner[entity.type]
                      : 'background-color:red'
                  "
                  align="center"
                >
                  <h3><i :class="ner_type_icon[entity.type]" /></h3>
                </div>
              </div>
              <div class="col-10">
                <div class="entity-name">
                  <h5 class="no-margin">
                    {{ entity._id }}
                  </h5>
                </div>
                <div class="entity-count">{{ entity.count }} Mention(s)</div>
              </div>
            </div>
          </div>
          <div v-else class="col-md-12 col-sm-12 col-lg-12">
            <div
              class="alert alert-danger mt-3"
              id="errorApiEl"
              role="alert"
              align="center"
            >
              <strong>Mohon maaf, data tidak tersedia! </strong> <br />
              Silahkan lakukan pencarian dengan parameter lain
            </div>
          </div>
        </div>
      </div>
      <div class="col-9 sna-container rounded px-gap">
        <div
          id="network"
          class="network-wrapper rounded shade"
          style="min-height: 705px; background-color: #000000"
        >
          <div
            v-if="nodes && edges"
            class="ml-2 mt-2 network-button align-items-center"
          >
            <div class="form-check mr-3">
              <input
                class="form-check-input mt-2"
                type="checkbox"
                id="physics"
                v-model.number="options.physics.enabled"
              />
              <label class="form-check-label small text-white" for="physics">
                Play Animation
              </label>
            </div>
            <div class="mr-2">
              <multiselect
                id="entity-type"
                v-model="entity_type"
                :options="entity_option_node"
                :multiple="true"
                placeholder="Pilih Jenis Entitas"
                label="text"
                track-by="text"
                style="min-width: 15rem !important"
              />
            </div>
            <div class="mr-3">
              <button
                class="btn btn-complete"
                @click="getNode"
                style="height: 2.6rem"
              >
                Simpan
              </button>
            </div>
          </div>
          <loader-component
            v-if="is_loading"
            style="padding-top: 35vh !important"
          />
          <div v-else>
            <Network
              v-if="nodes && edges"
              class="network w-100"
              ref="network"
              :nodes="nodes"
              :edges="edges"
              :options="options"
              :events="['click']"
              style="background-color: black; height: 75vh"
            >
            </Network>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <div class="subscribe-now bg-white rounded p-3">
          <p>Silahkan hubungi administrator untuk membuka fitur ini.</p>
        </div>
      </div>
    </div>
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import loader from "@/views/components/loader.vue";
import { Network } from "vue-vis-network";
import Multiselect from "vue-multiselect";

export default {
  name: "NEA",
  title: "Analytics NEA | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "loader-component": loader,
    Network,
    Multiselect,
  },
  data() {
    return {
      nodes: null,
      edges: null,
      options: {
        layout: {
          improvedLayout: false,
        },
        interaction: {
          hover: true,
        },
        physics: {
          enabled: false,
          forceAtlas2Based: {
            gravitationalConstant: -50,
            centralGravity: 0.01,
            springLength: 100,
            springConstant: 0.08,
            damping: 0.4,
            avoidOverlap: 0,
          },
          barnesHut: {
            gravitationalConstant: -2000,
            centralGravity: 0.3,
            springLength: 95,
            springConstant: 0.04,
            damping: 0.09,
            avoidOverlap: 0,
          },
          minVelocity: 0.75,
          maxVelocity: 50,
          solver: "forceAtlas2Based",
          timestep: 1,
        },
      },
      tour_steps: [],
      id_project: this.$store.getters.user.id_project,
      filter_topic: this.$store.getters.filter_topic,
      is_loading: false,
      topics: null,
      q_search: null,
      entity_option: [],
      entity_option_node: [
        {
          id: "PER",
          text: "Person",
        },
        {
          id: "FAC",
          text: "Facility",
        },
        {
          id: "ORG",
          text: "Organization",
        },
        {
          id: "LOC",
          text: "Location",
        },
        {
          id: "PRO",
          text: "Product",
        },
        {
          id: "EVT",
          text: "Event",
        },
        {
          id: "DTE",
          text: "Date",
        },
        {
          id: "OTN",
          text: "Other Name",
        },
      ],
      entity_result: [],
      selected_entity_detail: {},
      selected_entity: null,
      entity_type: null,
      ner_type_icon: this.$ner_icon,
      bg_ner: this.$bg_color,
      loading_state: {
        entity: false,
      },
      is_ner: this.$store.getters.user.project.project_detail.ner
        ? true
        : false,
    };
  },
  methods: {
    getNode: function () {
      this.is_loading = true;
      let params = {};
      let type_e = [];
      if (this.entity_type == null || this.entity_type.length == 0) {
        type_e = [
          "PER",
          "ORG",
          "LOC",
          "FAC",
          "PRO",
          "EVT",
          "TME",
          "DTE",
          "MEA",
        ];
      } else {
        for (let i = 0; i < this.entity_type.length; i++) {
          type_e[i] = this.entity_type[i].id;
        }
      }
      let type_val = `['${type_e.join("', '")}']`;
      params = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };

      if ("topic_selected" in this.$route.query) {
        params.topic_selected = this.$route.query.topic_selected;
      } else {
        if (this.filter_topic) {
          if (this.filter_topic.tipe == "topik") {
            params.topic = this.filter_topic.id;
          } else if (this.filter_topic.tipe == "group") {
            params.group = this.filter_topic.id;
          }
        }
      }
      if ("cakupan" in this.$route.query) {
        params.cakupan = this.$route.query.cakupan;
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query) {
        let api =
          process.env.VUE_APP_API_URL +
          "ner-nodes/" +
          this.id_project +
          "/" +
          this.selected_entity_detail._id +
          "?" +
          query +
          "&type=" +
          type_val;
        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.nodes = response.data.nodes;
              this.edges = response.data.links;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
    filterChange: function () {
      this.getData();
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.filterChange();
        });
    },
    compare: function (a, b) {
      if (a.node_type > b.node_type) {
        return 1;
      }
      if (a.node_type < b.node_type) {
        return -1;
      }
      return 0;
    },
    searchEntity: function () {
      let result;
      if (this.selected_entity) {
        result = this.entity_type_filter.filter((ent) =>
          ent._id.toString().toLowerCase().includes(this.q_search.toLowerCase())
        );
      } else {
        result = this.entity_data.filter((ent) =>
          ent._id.toString().toLowerCase().includes(this.q_search.toLowerCase())
        );
      }

      this.entity_result = result;
    },
    changeEntity: function (entity) {
      this.filterEntity(entity);
    },
    filterEntity: function (entity) {
      let result = this.entity_data.filter((ent) => ent.type == entity.id);
      this.entity_type_filter = result;
      this.entity_result = result;
    },
    getData: function () {
      let api = process.env.VUE_APP_API_URL + "ner_list/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.entity_data = [];
      this.entity_result = [];
      this.loading_state.entity = true;
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.entity_data = response.data.entity_list;
            this.entity_result = this.entity_data;
            this.entity_type_filter = this.entity_data;
            this.entity_type_count = response.data.entity_info;
            this.entity_option = [
              {
                id: "PER",
                text: "Person (" + this.entity_type_count["PER"] + ")",
              },
              {
                id: "FAC",
                text: "Facility (" + this.entity_type_count["FAC"] + ")",
              },
              {
                id: "ORG",
                text: "Organization (" + this.entity_type_count["ORG"] + ")",
              },
              {
                id: "LOC",
                text: "Location (" + this.entity_type_count["LOC"] + ")",
              },
              {
                id: "PRO",
                text: "Product (" + this.entity_type_count["PRO"] + ")",
              },
              {
                id: "EVT",
                text: "Event (" + this.entity_type_count["EVT"] + ")",
              },
              {
                id: "DTE",
                text: "Date (" + this.entity_type_count["DTE"] + ")",
              },
              {
                id: "OTN",
                text: "Other Name (" + this.entity_type_count["OTN"] + ")",
              },
            ];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading_state.entity = false;
        });
    },
    entityDetail: function (entity) {
      this.selected_entity_detail = entity;
      this.is_loading = true;
      this.getNode();
    },
  },
  watch: {
    selected_entity() {
      if (!this.selected_entity) {
        this.entity_result = this.entity_data;
      }
    },
  },
  created: function () {
    this.getTopic();
  },
  mounted: function () {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#cari-entitas",
      header: {
        title: "Cari Entitas",
      },
      content: `Masukkan kata kunci berupa nama entitas untuk mencari entitas yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#jenis-entitas",
      header: {
        title: "Cari Jenis Enitas",
      },
      content: `Pilih salahsatu jenis entitas untuk melakukan filter sesuai dengan jenis entitas yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#entitas",
      header: {
        title: "Daftar Entitas",
      },
      content: `Menampilkan daftar entitas dengan jumlah mention untuk setiap entitas.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#network",
      header: {
        title: "Grafik Network",
      },
      content: `Menampilkan grafik network terkait entitas yang dipilih`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.entity-result {
  max-height: 535px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.entity-result .row {
  padding: 10px;
}
.entity-result .row:hover {
  background: #d3eeff !important;
  cursor: pointer;
}
.bg-icon {
  padding: 2px 5px;
}
.bg-icon i {
  color: #ffffff;
}
.active {
  background: #d3eeff !important;
}
.entity-post-wrapper {
  height: 300px;
  overflow-y: scroll;
}
.network-button {
  position: absolute;
  z-index: 999;
  display: flex;
}
</style>